const NEW_CORE_CURRICULUM_START_DATE = '2026-09-01';

const usesNewCoreCurriculum = (date: string) => date >= NEW_CORE_CURRICULUM_START_DATE;

export const hasCoreCurriculumVersionChanged = (previousDate: string, nextDate: string) =>
    usesNewCoreCurriculum(previousDate) !== usesNewCoreCurriculum(nextDate);
